import React from 'react'

type IconProps = {
    className?: string
}

export const FilterIcon = ({ className }: IconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M5.5 10H14.5M3.5 6H16.5M8.5 14H11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)
